<template>
  <span class="pulse-dot"></span>
</template>

<script>
export default { name: 'PulseIndicator' };
</script>

<style lang="less" scoped>
.pulse-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--cyan);
  box-shadow: 0 0 0 0 rgba(67, 217, 255, 0.45);
  animation: pulse-anim 2s infinite;
  display: inline-block;
}

@keyframes pulse-anim {
  70% {
    box-shadow: 0 0 0 10px rgba(67, 217, 255, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(67, 217, 255, 0);
  }
}
</style>
